<div class="row">
  <div class="col s12">
    <h3 class="h3 chart-title margin-none">
      {{ 'groups.dashboard.students' | translate }}
      <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
    </h3>
  </div>
</div>
<div class="row">
  <div class="col s6">
    <lms-most-active-students-widget [data]="data" [key]="'mostActive'"></lms-most-active-students-widget>
  </div>
  <div class="col s6">
    <lms-last-finished-students-widget [data]="data" [key]="'lastFinished'"></lms-last-finished-students-widget>
  </div>
</div>
